import styled from 'styled-components';

const tricolor = {
  blobOuterTricolorDiameter: 12,
  blobTricolorDiameter: 10,
  blobTricolorSpacing: 4,
  cartridgeTricolorWidth: 26
};

const getDotX = (source, col) => {
  const center =
    source.cartridgeTricolorWidth / 2 - source.blobTricolorDiameter / 2 - 1;
  if (col === 0) {
    return center - source.blobTricolorDiameter * (3 / 4);
  }

  if (col === 2) {
    return center + source.blobTricolorDiameter * (3 / 4);
  }
  return center;
};

const getDotY = (source, row) => {
  const center =
    source.cartridgeTricolorWidth / 2 - source.blobTricolorDiameter / 2;
  if (row === 0) {
    return center - source.blobTricolorDiameter * (3 / 5);
  }

  return center + source.blobTricolorDiameter * (3 / 5);
};

export const Container = styled.div`
  box-sizing: border-box;
  height: ${tricolor.cartridgeTricolorWidth}px;
  position: relative;
  width: ${tricolor.cartridgeTricolorWidth}px;
`;

export const Dot = styled.div`
  border-radius: 8px;
  box-sizing: border-box;
  display: inline-block;
  height: ${tricolor.blobOuterTricolorDiameter}px;
  padding: 1px;
  position: absolute;
  width: ${tricolor.blobOuterTricolorDiameter}px;

  > div {
    border-radius: 8px;
    color: transparent;
    height: ${tricolor.blobTricolorDiameter}px;
    width: ${tricolor.blobTricolorDiameter}px;
  }

  &.cyan {
    left: ${getDotX(tricolor, 0)}px;
    top: ${getDotY(tricolor, 1)}px;

    > div {
      background-color: #03a4f0;
    }
  }

  &.magenta {
    left: ${getDotX(tricolor, 2)}px;
    top: ${getDotY(tricolor, 1)}px;

    > div {
      background-color: #f7448b;
    }
  }

  &.yellow {
    left: ${getDotX(tricolor, 1)}px;
    top: ${getDotY(tricolor, 0)}px;

    > div {
      background-color: #ffd906;
    }
  }

  &.black > div {
    background-color: #000000;
    color: #ffffff;
  }
`;
